export default function UseMobile() {
  return (
    <div>
      This site is not currently available on mobile devices. Please visit on a desktop or laptop
      computer.
    </div>
  );
}
